export const SET_COLOR_USER = 'SET_COLOR_USER';

export interface IAvatarTypes {
    SET_COLOR_USER: {
        id: string;
    }
}